// getPackageFromOfferForOrderItem finds and returns the package, given an order item
import getPackageFromOffer from 'lib/offer/getPackageFromOffer'
import getPackageFromOfferByKey from './getPackageFromOfferByKey'
import { OFFER_TYPE_ALWAYS_ON } from 'constants/offer'

export default function getPackageFromOfferForOrderItem(
  offer: App.Offer,
  orderItem: App.OrderItem,
) {
  if (orderItem.offer.type === OFFER_TYPE_ALWAYS_ON) {
    // LPC doesn't always have ID as not all packages come from SF, so we search by uniqueKey
    return getPackageFromOfferByKey(offer, orderItem.package.uniqueKey)
  }
  return getPackageFromOffer(offer, orderItem.package.id, orderItem.duration)
}
